import { right } from 'fp-ts/Either';
import ReadWidgetDataClient from 'use-case/widgets/data/read/readWidgetDataClient';
import ReadWidgetDataCriteria from 'use-case/widgets/data/read/readWidgetDataCriteria';
import RichTextData from 'domain/entity/widgets/RichTextData';

const readFrameDataApiClient: ReadWidgetDataClient = (criteria: ReadWidgetDataCriteria) =>
    Promise.resolve(right(new RichTextData(criteria.frameText)));

export default readFrameDataApiClient;
